import React, { useMemo } from 'react';
import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ModuleAlertsPage from '../../shared/components/ModuleAlertsPage';
import { formatPointageDate, SAUDI_DEFAULT_TIMETRACKING_CONFIG } from './pointageHelpers';

const PointageAlertsPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.pointage.pages.pointageAlertsPage.${key}`, opts);

  const today = new Date().toISOString().split('T')[0];
  const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];

  const alerts = useMemo(() => [
    {
      id: 1,
      type: 'warning',
      priority: 'high',
      title: p('alert_lateness_title'),
      message: p('alert_lateness_message', {
        minutes: SAUDI_DEFAULT_TIMETRACKING_CONFIG.latenessThreshold,
      }),
      date: today,
      dateLabel: formatPointageDate(today),
      read: false,
    },
    {
      id: 2,
      type: 'error',
      priority: 'critical',
      title: p('alert_missing_punch_title'),
      message: p('alert_missing_punch_message'),
      date: today,
      dateLabel: formatPointageDate(today),
      read: false,
    },
    {
      id: 3,
      type: 'info',
      priority: 'medium',
      title: p('alert_overtime_title'),
      message: p('alert_overtime_message', {
        rate: '150%',
        maxHours: SAUDI_DEFAULT_TIMETRACKING_CONFIG.maxAnnualOvertimeHours,
      }),
      date: yesterday,
      dateLabel: formatPointageDate(yesterday),
      read: true,
    },
    {
      id: 4,
      type: 'warning',
      priority: 'medium',
      title: p('alert_ramadan_title'),
      message: p('alert_ramadan_message', {
        hours: SAUDI_DEFAULT_TIMETRACKING_CONFIG.ramadanDailyHours,
      }),
      date: today,
      dateLabel: formatPointageDate(today),
      read: false,
    },
    {
      id: 5,
      type: 'info',
      priority: 'low',
      title: p('alert_prayer_break_title'),
      message: p('alert_prayer_break_message', {
        minutes: SAUDI_DEFAULT_TIMETRACKING_CONFIG.prayerBreakMinutes,
      }),
      date: today,
      dateLabel: formatPointageDate(today),
      read: true,
    },
  ], [p, today, yesterday]);

  return (
    <ModuleAlertsPage
      moduleName={p('module_name')}
      moduleIcon={Clock}
      alerts={alerts.map((a) => ({ ...a, date: a.dateLabel || a.date }))}
    />
  );
};

export default PointageAlertsPage;
